import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import ButtonGroup from "@mui/material/ButtonGroup";
import Button from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClearIcon from "@mui/icons-material/Clear";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";

import StaticDatePicker from '@mui/lab/StaticDatePicker';
import TextField from '@mui/material/TextField';

import makeStyles from '@mui/styles/makeStyles';

import moment from "moment";
import AddIcon from '@mui/icons-material/Add';
import IconButton from "@mui/material/IconButton";
const useStyles = makeStyles((theme) => ({
    popper: {
        zIndex: theme.zIndex.drawer - 1,
    },
    filterLabel: {
        textTransform: "uppercase",
        fontWeight: 300,
    },
    listElement: {
        fontSize: "90%",
        textTransform: "uppercase",
        fontWeight: 300,
    },
    filterButton: {
        height: "20px"
    },
    clearButton:{
        padding: "0",
        minWidth: "20px"
    },
    icon:{
        fontSize: "15px"
    },
    filterName: {
        textAlign: "left",
        fontSize: "11px",
        marginLeft: "15px",
        marginTop: "-9px",
        background: "#252525",
        width: "fit-content",
        padding: "0px 4px",
        cursor: "pointer",
        color: "#2280f7",
        display: "flex",
        alignItems: "center"
    }
}));

export function FilterAddButton(props) {
    const [elements, setElements] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(undefined);

    const {t, i18n} = useTranslation();

    const filter = props.config.filter;
    const defaultDateValue = filter.default ? moment().startOf("day").subtract(
        filter.default[0], filter.default[1]) : null;
    const [dateValue, setDateValue] = React.useState(defaultDateValue);

    const anchorRef = React.useRef(null);
    const classes = useStyles();

    useEffect(() => {
        if (defaultDateValue) {
            if (props.onChange) {
                props.onChange(defaultDateValue);
            }
        }
    }, []);

    useEffect(()=>{
        if(filter.type === "date") {
            if(filter.__filterValue)
                setDateValue(moment(filter.__filterValue))
            else
                setDateValue(null)
        } else {
            let index = _.findIndex(elements, (el) => {
                return el === filter.__filterValue
            });
            if(index>0)setSelectedIndex(index);
        }
    },[elements]);

    const updateDateValue = date => {
        setOpen(false);
        setDateValue(date);
        if (props.onChange) {
            props.onChange(date);
        }
    };

    const updateSelected = (index) => {
        setSelectedIndex(index);
        if (props.onChange) {
            props.onChange(index !== undefined ? elements[index] : undefined);
        }
    };
    const handleMenuItemClick = (event, index) => {
        setOpen(false);
        updateSelected(index);
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {
        let elementsLocal = new Set();
        if (props.data) {
            _.forEach(props.data, dataElement => {
                // const val = _.get(dataElement, props.field, t("Undefined"));
                const val = _.get(dataElement, props.field, null);
                if(filter.type === "string" && !props.filtersValues?.includes(val))
                    elementsLocal.add(val);
            });
        }
        setElements(_.sortBy(Array.from(elementsLocal), function (v) {
            return v ? v.toLowerCase() : "";
        }));
    }, [props.data, props.field, props.filtersValues]);

    const renderValue = what => {
        let returnValue = (props.render ? props.render(what) : what);
        if (!returnValue) {
            returnValue = t("Undefined");
        }
        return returnValue;
    };

    const renderDateValue = what => {
        let returnValue = (props.render ? props.render(what) :
            (what ? what.format(filter.format) : ""));
        if (!returnValue) {
            returnValue = t("No date");
        }
        return returnValue;
    };

    return (
        <div style={{textAlign: "center"}}  >
            {props.filtersValues !== undefined && <div
                ref={anchorRef}
                onClick={handleToggle}
                className={classes.filterName}>  <AddIcon fontSize={"12px"}/> {props.config.name} </div> }

            {props.filtersValues === undefined &&
                <Button size="small"
                        ref={anchorRef}
                        style={{padding: 0}}
                        startIcon={filter.type === "date"? null: <AddIcon/>}
                        onClick={handleToggle}>

                    {filter.type === "date" &&  <span> Set { props.config.name} </span>}
                    {filter.type === "string" && <span>{props.config.name}</span>}
                </Button>
            }
                <Popper className={classes.popper} open={open}
                        placement="bottom-start"
                        anchorEl={anchorRef.current} role={undefined} transition
                        disablePortal>
                    {({TransitionProps, placement}) => (
                        <Grow {...TransitionProps}>
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <div>
                                        {filter.type === "string" &&
                                        <MenuList>
                                            {elements.map((option, index) => (
                                                <MenuItem
                                                    className={classes.listElement}
                                                    key={option}
                                                    onClick={(event) => handleMenuItemClick(event, index)}
                                                >
                                                    {renderValue(option)}
                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                        }
                                        {filter.type === "date" &&
                                        <StaticDatePicker
                                            // autoOk
                                            showToolbar={false}
                                            value={dateValue}
                                            onChange={updateDateValue}
                                            renderInput={(inp) => <TextField {...inp} />}
                                        />
                                        }
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
    );
}
